import { Star, ExternalLink } from "lucide-react";
import { BUSINESS, REVIEWS } from "../data/business";
import { SectionHeading } from "../components/SectionHeading";
import { ReviewCard } from "../components/ReviewCard";
import { Reveal } from "../components/Reveal";
import { CTASection } from "../components/CTASection";
import { useSEO } from "../hooks/useSEO";

export default function Reviews() {
  useSEO(
    "Reviews | New Lookz Hair Salon — Gandhi Nagar, Hyderabad",
    "See what customers say about New Lookz Hair Salon in Gandhi Nagar, Hyderabad — rated 4.3 on Google with hundreds of reviews.",
    "/reviews"
  );

  return (
    <>
      <section className="bg-ink grain" data-testid="reviews-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-12 items-center">
          <SectionHeading
            dark
            eyebrow="Reviews"
            title="What Our Customers Say"
            text="We never invent reviews. Verified Google reviews will appear here as they are confirmed."
          />
          <Reveal delay={0.15}>
            <div className="rounded-xl bg-coal border border-copper/25 p-8 text-center" data-testid="google-rating-summary">
              <p className="font-display font-extrabold text-white text-6xl">{BUSINESS.googleRating}</p>
              <div className="flex justify-center gap-1 text-copper my-3" aria-label={`${BUSINESS.googleRating} out of 5 stars on Google`}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={20} fill={i < 4 ? "currentColor" : "none"} aria-hidden="true" />
                ))}
              </div>
              <p className="text-white/60 text-sm">{BUSINESS.googleReviewCount} reviews on Google</p>
              <a
                href={BUSINESS.googleReviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-google-cta"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-copper px-7 py-3 font-display font-bold text-ink text-sm transition-colors hover:bg-copper-hover"
              >
                View Google Reviews <ExternalLink size={14} aria-hidden="true" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="grid md:grid-cols-3 gap-5">
            {REVIEWS.map((r, i) => <ReviewCard key={i} review={r} index={i} />)}
          </div>
          <Reveal className="mt-8">
            <p className="text-xs text-mute">
              Placeholder blocks — verified Google reviews will be inserted into this editable section.
              Review data lives in <code className="text-copper">src/data/business.js</code>.
            </p>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
